import React from 'react';
import Head from 'next/head';
import Link from 'next/link';
import { PrivacyStyles } from '@components/Shared/LegalPrivacy/LegalAndPrivacy.styled';

const Privacy = () => {
  return (
    <PrivacyStyles>
      <Head>
        <title>Privacy | Clayton Homes</title>
        <meta
          name="description"
          content="We respect your privacy and are committed to providing a transparent notice of our Privacy Notice."
        />
      </Head>
      <div className="privacyContainer">
        <h1 className="privacyHeader">Privacy Policies</h1>
        <div className="privacyLinkItem">
          <Link href="/privacy/multi-state-privacy-policy/">
            Multi-State Notice at Collection and Privacy Policy
          </Link>
        </div>
        <div className="privacyLinkItem">
          <Link href="/privacy/clayton-employee-ca-notice-collection-privacy-policy/">
            Clayton Employee California Notice at Collection and Privacy Policy
          </Link>
        </div>
        <div className="privacyLinkItem">
          <Link href="/privacy/financial-institution-privacy-policy/">
            Financial Institution Privacy Policy
          </Link>
        </div>
        <div className="privacyLinkItem text-lg">
          We are aware of multiple cases where individuals have been posing as
          our recruiters and contacting job seekers with fake job opportunities.
          If you have experienced this activity, please immediately file a
          complaint to the Internet Crime Complaint Center.{' '}
          <Link href="https://www.ic3.gov/">Click Here.</Link>
        </div>
      </div>
    </PrivacyStyles>
  );
};

export default Privacy;
